const
  NAME               = 'gotoHomeBubble',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],

  CLASS       = 'voc-alert-number--fade-in',
  DELAY_TIMES = [2000, 10000, 30000, 45000],
  SESSION_KEY = 'squido-goto-home-bubble-rendered'
;

class GotoHomeBubble {
  constructor(element$) {
    this._element$ = element$;
    setTimeout(this.addClass.bind(this), _randomTimeout.call(this));
  }

  addClass() {
    if ('sessionStorage' in window) {
      if (window.sessionStorage.getItem(SESSION_KEY)) {
        window.sessionStorage.removeItem(SESSION_KEY);
      } else {
        this._element$.addClass(CLASS);
        window.sessionStorage.setItem(SESSION_KEY, 'true');
      }
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new GotoHomeBubble($(this));
    });
  }
}

$.fn[NAME]             = GotoHomeBubble._jQueryInterface;
$.fn[NAME].Constructor = GotoHomeBubble;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return GotoHomeBubble._jQueryInterface;
};

export default GotoHomeBubble;

/* Private */

function _randomTimeout() {
  // NOTE returns a random element from the DELAY_TIMES array
  return DELAY_TIMES[Math.floor(Math.random() * DELAY_TIMES.length)];
}



// WEBPACK FOOTER //
// ./src/plugins/goto-home-bubble.js